import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ServiceDto extends BaseEntityDto {
  code: string;
  name: string;
  externalCode?: string;

  toString(): string {
    return `${this.code} - ${this.name}`;
  }
}
